<template>
  <div id="Oct2023" class="202310 relative">
    <div class="absolute z-0 bean1"><img src="~@/assets/images/202310/bg-bean-01.png" class="object-contain block mx-auto"></div>
    <div class="absolute z-0 bean2"><img src="~@/assets/images/202310/bg-bean-02.png" class="object-contain block mx-auto"></div>
    <div class="absolute z-0 bean3"><img src="~@/assets/images/202310/bg-bean-03.png" class="object-contain block mx-auto"></div>
    <div class="absolute z-0 bean4"><img src="~@/assets/images/202310/bg-bean-04.png" class="object-contain block mx-auto"></div>
    <div class="fixed z-50 hidden xl:block" :class="{ 'fixed-btn': isMenu, 'hidden-btn': !isMenu}">
      <!-- <a class="toggle-btn absolute cursor-pointer p-6 block" @click="isMenu = !isMenu">
        <img src="~@/assets/images/202307/menu/right.png" class="object-contain w-full">
      </a> -->
      <a class="block px-3">
        <img src="~@/assets/images/202310/menubar/memu-off_01.png" class="object-contain">
      </a>
      <a class="hover-item cursor-pointer block px-3" @click="toTop('.section1')">
        <img src="~@/assets/images/202310/menubar/memu-off_02.png" class="off object-contain">
        <img src="~@/assets/images/202310/menubar/memu-on_02.png" class="on object-contain">
      </a>
      <a class="hover-item cursor-pointer block px-3" @click="toTop('.section2')">
        <img src="~@/assets/images/202310/menubar/memu-off_03.png" class="off object-contain">
        <img src="~@/assets/images/202310/menubar/memu-on_03.png" class="on object-contain">
      </a>
      <a class="hover-item cursor-pointer block px-3" @click="toTop('.section3')">
        <img src="~@/assets/images/202310/menubar/memu-off_04.png" class="off object-contain">
        <img src="~@/assets/images/202310/menubar/memu-on_04.png" class="on object-contain">
      </a>
      <a class="hover-item cursor-pointer block px-3" @click="toTop('.section4')">
        <img src="~@/assets/images/202310/menubar/memu-off_05.png" class="off object-contain">
        <img src="~@/assets/images/202310/menubar/memu-on_05.png" class="on object-contain">
      </a>
      <a class="hover-item cursor-pointer block px-3" @click="toTop('.banner')">
        <img src="~@/assets/images/202310/menubar/memu-off_06.png" class="off object-contain">
        <img src="~@/assets/images/202310/menubar/memu-on_06.png" class="on object-contain">
      </a>
    </div>
    <div class="relative outer mx-auto h-full w-full px-4">
      <div class="banner flex flex-wrap w-full relative z-40">
        <router-link class="absolute logo z-10" :to="{ name: 'index' }" >
          <img src="~@/assets/images/202310/liveabc-LOGO.png" class="object-contain block">
        </router-link>
        <div class="w-2/12 md:w-3/12 relative banner-left">
          <div data-aos="fade-right" data-aos-easing="ease" data-aos-once="true" class="absolute banner-bean z-0 hidden md:block"><img src="~@/assets/images/202310/bg-bean-01.png" class="object-contain block" style="transform: rotate(-30deg);"></div>
          <div data-aos="fade-right" data-aos-easing="ease" data-aos-once="true" class="absolute banner-people hidden md:block"><img src="~@/assets/images/202310/MASTER-PIC-L.png" class="object-contain block z-10"></div>
          <div data-aos="zoom-in" data-aos-easing="ease" data-aos-once="true" data-aos-delay="100" class="absolute banner-sale"><img src="~@/assets/images/202310/babo-left.png" class="object-contain block"></div>
          <div class="absolute banner-star"><img src="~@/assets/images/202310/star-left.png" class="object-contain block"></div>
        </div>
        <div class="w-8/12 md:w-6/12 flex justify-center pt-10 md:pt-20 pb-2 mb:pb-8">
          <img src="~@/assets/images/202310/master-title.png" class="object-contain hidden md:block">
          <img src="~@/assets/images/202310/m/master-title-mobile.png" class="object-contain block md:hidden">
        </div>
        <div class="w-2/12 md:w-3/12 relative banner-right">
          <div data-aos="zoom-in" data-aos-easing="ease" data-aos-once="true" data-aos-delay="100" class="absolute banner-sale"><img src="~@/assets/images/202310/babo-right.png" class="object-contain block"></div>
          <div data-aos="fade-left" data-aos-easing="ease" data-aos-once="true" class="absolute banner-bean hidden md:block"><img src="~@/assets/images/202310/bg-bean-01.png" class="object-contain block" style="transform: rotate(51deg);"></div>
          <div data-aos="fade-left" data-aos-easing="ease" data-aos-once="true" class="absolute banner-people hidden md:block"><img src="~@/assets/images/202310/MASTER-PIC-R.png" class="object-contain block"></div>
          <div class="absolute banner-star"><img src="~@/assets/images/202310/star-right.png" class="object-contain block"></div>
        </div>
        <div class="w-full flex justify-center md:hidden">
          <div class="mr-1"><img src="~@/assets/images/202310/m/photo-left-mobile.png" class="object-contain block"></div>
          <div class="ml-1"><img src="~@/assets/images/202310/m/photo-right-mobile.png" class="object-contain block"></div>
        </div>
      </div>
      <main class="main mx-auto z-30 relative">
        <div class="section section1 pb-10 mb-12 md:mb-16">
          <div class="title-order"><img src="~@/assets/images/202310/A-titile-01.png" class="object-contain block"></div>
          <div class="title-main mb-2"><img src="~@/assets/images/202310/A-titile-02.png" class="object-contain block mx-auto"></div>
          <div class="section-inner py-8 px-4 mx-4 md:mx-8">
            <a href="https://store.liveabc.com/products/magazine/sale?tag=289" target="_blank"><img src="~@/assets/images/202310/A-01.png" class="object-contain block mx-auto"></a>
            <div><img src="~@/assets/images/202310/A-02.png" class="object-contain block mx-auto"></div>
            <a href="https://store.liveabc.com/products/magazine/sale?tag=289" target="_blank"><img src="~@/assets/images/202310/A-03.png" class="object-contain block mx-auto"></a>
          </div>
        </div>
        <div class="section section2 pb-10 mb-12 md:mb-16">
          <div class="title-order mb-2">
            <img src="~@/assets/images/202310/B-title-01.png" class="object-contain block"></div>
          <div class="mb-4 flex justify-end ml-6 lg:ml-0">
            <img src="~@/assets/images/202310/B-title-02.png" class="object-contain lg:-mr-16 -mt-12 md:-mt-24 hidden md:block">
            <img src="~@/assets/images/202310/m/B-title-02-mobile.png" class="object-contain block md:hidden -mt-12">
          </div>
          <div class="section-inner py-6 md:py-8 mx-4 md:mx-8">
            <div class="flex flex-wrap mb-6">
              <router-link :to="{ name: 'detail', params: { category: 'book', id: item.id } }" class="w-1/2 p-2" v-for="(item, index) in bookData1" :key="index"><img :src="item.img_url" class="object-contain block mx-auto"></router-link>
            </div>
          </div>
          <a href="https://store.liveabc.com/products/magazine/sale?tag=290" target="_blank"><img src="~@/assets/images/202310/B-button-more.png" class="object-contain block mx-auto -mt-6 md:-mt-8 w-2/5 md:w-1/3"></a>
        </div>
        <div class="section section3 pb-10 mb-12 md:mb-16 relative">
          <div class="title-order"><img src="~@/assets/images/202310/C-tittle-01.png" class="object-contain block"></div>
          <div class="title-main">
            <img src="~@/assets/images/202310/C-tittle-02.png" class="object-contain mx-auto">
          </div>
          <div class="absolute people1"><img src="~@/assets/images/202310/C-pic-01.png" class="object-contain block mx-auto"></div>
          <div class="section-inner py-8 px-6 md:px-4 mx-4 md:mx-8">
            <a href="https://store.liveabc.com/products/magazine/sale?tag=291" class="mb-4">
              <img src="~@/assets/images/202310/C-info-01.png" class="object-contain mx-auto hidden md:block">
              <img src="~@/assets/images/202310/m/C-info-01-mobile.png" class="object-contain mx-auto block md:hidden">
            </a>
            <a href="https://store.liveabc.com/package/detail/8881" class="mb-4">
              <img src="~@/assets/images/202310/C-info-03.png" class="object-contain block mx-auto">
            </a>
            <iframe
              class="mb-3"
              src="https://liveabc-dokodemo.azurewebsites.net/scorm/post/JPN1906L20/"
              width="100%"
              height="600"
              frameborder="0"
              allowfullscreen
              scrolling="no"
              sandbox="allow-same-origin allow-scripts allow-popups allow-forms">
              <p>
                <a href="https://developer.mozilla.org/zh-CN/docs/Glossary">
                  Fallback link for browsers that don't support iframes
                </a>
              </p>
            </iframe>
            <div class="mb-6"><img src="~@/assets/images/202310/C-tittle-03.png" class="object-contain block mx-auto"></div>
            <a href="https://store.liveabc.com/products/magazine/sale?tag=291" class="mb-3 block" target="_blank"><img src="~@/assets/images/202310/order-button.png" class="object-contain block mx-auto w-1/5 md:w-auto"></a>
            <div><img src="~@/assets/images/202310/C-info-04.png" class="object-contain block mx-auto"></div>
          </div>
        </div>
        <div class="section section4 pb-10 mb-8 relative">
          <div class="title-order"><img src="~@/assets/images/202310/D-tittle-01.png" class="object-contain block"></div>
          <div class="title-main"><img src="~@/assets/images/202310/D-tittle-02.png" class="object-contain block mx-auto"></div>
          <div class="absolute people2"><img src="~@/assets/images/202310/D-pic-01.png" class="object-contain block mx-auto"></div>
          <a href="https://store.liveabc.com/products/magazine/sale?tag=292" target="_blank" class="py-8 px-4 mx-4 md:mx-8 mb-2">
            <div><img src="~@/assets/images/202310/D-info-01.png" class="object-contain block mx-auto"></div>
          </a>
          <a href="https://store.liveabc.com/products/magazine/sale?tag=292" target="_blank">
            <img src="~@/assets/images/202310/order-button.png" class="object-contain block mx-auto -mt-6 md:-mt-8 w-1/5 md:w-auto">
          </a>
        </div>
      </main>
      <footer class="py-10">
        <router-link :to="{ name: 'index' }" class="text-white text-center text-lg lg:text-xl block">更多優惠請見LiveABC官網</router-link>
      </footer>
    </div>
  </div>
</template>
<script>
import jump from 'jump.js'
export default {
  name: 'Oct2023',
  metaInfo () {
    return {
      title: '訂雜誌送點讀筆！LiveABC雙10生日狂歡節等你狂買',
      titleTemplate: null
    }
  },
  data () {
    return {
      isMenu: true,
      renderComponent: false,

      bookData1: [
        { id: 8993, img_url: require('@/assets/images/202310/Frame 1.png') },
        { id: 7701, img_url: require('@/assets/images/202310/Frame 2.png') },
        { id: 8881, img_url: require('@/assets/images/202310/Frame 3.png') },
        { id: 8733, img_url: require('@/assets/images/202310/Frame 4.png') },
        { id: 7800, img_url: require('@/assets/images/202310/Frame 5.png') },
        { id: 8244, img_url: require('@/assets/images/202310/Frame 6.png') }
      ]
    }
  },
  mounted () {
  },
  methods: {
    toTop (n) {
      jump(`${n}`, {
        duration: 500,
        offset: 0
      })
    }
  }
}
</script>
<style lang="scss" scoped>
#Oct2023 {
  background-color: #6144BF;
  .outer {
    max-width: 1440px;
  }
  .bean1 {
    mix-blend-mode: soft-light;
    filter: blur(150px);
    top: -5%;
    @media (max-width: 768px) {
      width: 200%;
      left: 50%;
      transform: translateX(-50%);
      filter: blur(75px);
    }
  }
  .bean2 {
    // transform: rotate(51.849deg);
    mix-blend-mode: soft-light;
    filter: blur(150px);
    top: 20%;
    right: -30%;
    @media (max-width: 768px) {
      width: 200%;
      filter: blur(75px);
    }
  }
  .bean3 {
    // transform: rotate(-13.889deg);
    filter: blur(150px);
    mix-blend-mode: soft-light;
    top: 50%;
    left: -30%;
    @media (max-width: 768px) {
      width: 200%;
      filter: blur(75px);
    }
  }
  .bean4 {
    // transform: rotate(51.849deg);
    mix-blend-mode: soft-light;
    filter: blur(150px);
    top: 80%;
    right: -30%;
    @media (max-width: 768px) {
      width: 200%;
      filter: blur(75px);
    }
  }

  .toggle-btn {
    top: 20%;
    left: -40%;
  }
  .fixed-btn {
    top: 50%;
    transform: translateY(-50%);
    right: 0%;
    transition: 0.3s;
  }
  .hidden-btn {
    top: 50%;
    transform: translateY(-50%);
    right: -174px;
    transition: 0.3s;
  }
  .hover-item {
    .on {
      display: none;
    }
    &:hover {
      .off {
        display: none;
      }
      .on {
        display: block;
      }
    }
  }
  .main {
    max-width: 1080px;
  }
  .banner {
    .logo {
      left: 0%;
      top: 4%;
      width: 100%;
      @media (max-width: 768px) {
        width: 20%;
        left: 0%;
      }
    }
    .banner-left {
      .banner-star {
        left: 0;
        bottom: 0;
        mix-blend-mode: soft-light;
        opacity: 0.5;
        animation: shine1 2s linear infinite;
        animation-delay: 1s;
        @media (max-width: 768px) {
          left: 0;
          top: 30%;
        }
      }
      .banner-bean {
        width: 220%;
        height: auto;
        right: 10%;
      }
      .banner-people {
        width: 110%;
        height: auto;
        left: 0;
        top: -8%;
      }
      .banner-sale {
        width: 80%;
        right: 0;
        top: 50%;
        @media (max-width: 768px) {
          width: 100%;
        }
        @media (max-width: 640px) {
          right: -20%;
          width: 120%;
        }
      }
    }
    .banner-right {
      .banner-star {
        right: 0;
        top: 0;
        mix-blend-mode: soft-light;
        opacity: 0.5;
        animation: shine1 2s linear infinite;
      }
      .banner-bean {
        width: 180%;
        height: auto;
        left: 0%;
        bottom: -40%;
      }
      .banner-people {
        width: 130%;
        height: auto;
        right: -2em;
        bottom: 0;
        @media (max-width: 768px) {
          width: 160%;
        }
      }
      .banner-sale {
        width: 80%;
        left: 0;
        top: 15%;
        @media (max-width: 768px) {
          left: -10%;
          top: 10%;
          width: 100%;
        }
        @media (max-width: 640px) {
          left: -40%;
          top: 20%;
          width: 160%;
        }
      }
    }
    @keyframes shine1 {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 0.7;
      }
    }
  }

  .section {
    border-radius: 50px;
    background: var(--ffffff, #FFF);
    box-shadow: 0px 4px 120px 0px #5C4DFF inset, 5px 5px 15px 0px rgba(0, 0, 0, 0.25);
    .title-order {
      width: 20%;
    }
    .people1 {
      top: -7%;
      right: -10%;
      width: 30%;
      @media (max-width: 768px) {
        top: -4%;
        width: 25%;
        right: -4%;
      }
    }
    .people2 {
      top: -7.5%;
      right: -10%;
      width: 30%;
      @media (max-width: 768px) {
        top: 0%;
        width: 25%;
        right: 0%;
      }
    }
    .section-inner {
      border-radius: 50px;
      border: 3px solid var(--5-c-4-dff, #5C4DFF);
      background: rgba(255, 255, 255, 0.7);
    }

    &.section1 {
      .title-main {
        img {
          width: 60%;
        }
      }
    }
    &.section3 {
      .title-main {
        img {
          width: 60%;
        }
      }
    }
    &.section4 {
      .title-main {
        img {
          width: 60%;
        }
      }
    }
  }
}
</style>
